import Table from "Components/Admin/Table";

const ErrorTable = ({
  errors,
  title = "Corrija os erros abaixo para continuar",
  tableName = "Erros encontrados",
  columns = [],
  ...props
}) => {
  return (
    <>
      <h3>{title}</h3>
      <Table
        name={tableName}
        data={errors}
        columns={[{ Header: "Erro", accessor: "error" }, ...columns]}
        {...props}
      />
    </>
  );
};

export default ErrorTable;
